import Axios from "@/plugins/Axios";

export class CarteirinhaService {
  async baixar(matricula) {
    const response = await Axios().get(`/notifiq/carteirinha/cartao/${matricula.id}`, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `carteirinha_${matricula.aluno.codigo}.pdf`;
    link.click();

    return response;
  }

  async impressao(matricula_id) {
    const response = await Axios().get(`/cartao/${matricula_id}`, {
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const link = document.createElement("a");
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    link.href = window.URL.createObjectURL(blob);
    iframe.src = link.href;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      iframe.contentWindow.print();
    };

    return response;
  }

  async arquivo(matricula_id) {
    const response = await Axios().get(`/cartao/${matricula_id}`, {
      responseType: "arraybuffer",
    });

    return new Blob([response.data], { type: "application/pdf" });
  }

  async visualizacao(matricula_id) {
    const response = await Axios().get(`/notifiq/carteirinha/visualizacao/${matricula_id}`);
    return response.data;
  }

  async perfil(matricula_id) {
    try {
      const response = await Axios().get(`/notifiq/carteirinha/perfil/${matricula_id}`, {
        responseType: "arraybuffer",
      });

      if (!response.data) return null;

      const blob = new Blob([response.data], { type: "image/png" });
      return URL.createObjectURL(blob);
    } catch (error) {
      return null;
    }
  }

  async perfilBase64(matricula_id) {
    try {
      const response = await Axios().get(`/notifiq/carteirinha/perfil-base64/${matricula_id}`, {
        responseType: "application/json",
      });
      return response.data;
    } catch (error) {
      return null;
    }
  }

  async cartaoImageBase64(matricula_id) {
    try {
      const response = await Axios().get(`/notifiq/carteirinha/cartao-image/${matricula_id}`, {
        responseType: "application/json",
      });
      return response.data;
    } catch (error) {
      return null;
    }
  }
}

export default new CarteirinhaService();
